import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center text-center" }
const _hoisted_3 = { class: "marcth my-8" }
const _hoisted_4 = { class: "table border rounded bg-white table-striped-rows shadow" }
const _hoisted_5 = {
  class: "bg-primary",
  colspan: "10"
}
const _hoisted_6 = { class: "h3 text-center text-white" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "PARTIDO")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "FECHA")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "HORA")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "GRUPO")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "UNIFORME")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "EQUIPO 1")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "VS")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "EQUIPO 2")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "UNIFORME")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "bg-primary" }, [
      /*#__PURE__*/_createElementVNode("h5", { class: "h6 text-center text-white" }, "SEDE")
    ])
  ])
], -1)
const _hoisted_8 = { class: "border text-center fw-bolder" }
const _hoisted_9 = { class: "border" }
const _hoisted_10 = { class: "border fw-bolder" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "border text-center fw-bolder" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  class: "border text-center fw-bolder",
  innerHTML: 'vs'
}, null, -1)
const _hoisted_17 = { class: "border text-center fw-bolder" }
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  class: "border text-center fw-bolder",
  colspan: "9"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_radio_group, {
        modelValue: _ctx.selectedFecha,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFecha) = $event)),
        size: "large",
        onChange: _ctx.getEncuentro
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nroFechas, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_radio_button, {
              key: index,
              label: item
            }, {
              default: _withCtx(() => [
                _createTextVNode("Fecha " + _toDisplayString(item), 1)
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_5, [
              _createElementVNode("h5", _hoisted_6, "PROGRAMACIÓN " + _toDisplayString(_ctx.selectedFecha) + "° FECHA", 1)
            ])
          ])
        ]),
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMeetings, (subItem, subIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `sj-${subIndex}`
            }, [
              (subItem.idgroup1 != null && subItem.idgroup2 != null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(subItem.nroMatch), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(subItem.dateMatch), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(subItem.timeMatch), 1),
                    _createElementVNode("td", {
                      class: "border text-center fw-bolder",
                      innerHTML: subItem.groupAsciiLetter
                    }, null, 8, _hoisted_11),
                    _createElementVNode("td", {
                      class: "border text-center fw-bolder",
                      innerHTML: subItem.uniform1
                    }, null, 8, _hoisted_12),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          class: "w-30px h-30px",
                          src: subItem.equipos[0].image_path
                        }, null, 8, _hoisted_15),
                        _createElementVNode("p", null, _toDisplayString(subItem.equipos[0].business), 1)
                      ])
                    ]),
                    _hoisted_16,
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("img", {
                          class: "w-30px h-30px",
                          src: subItem.equipos[1].image_path
                        }, null, 8, _hoisted_19),
                        _createElementVNode("p", null, _toDisplayString(subItem.equipos[1].business), 1)
                      ])
                    ]),
                    _createElementVNode("td", {
                      class: "border text-center fw-bolder",
                      innerHTML: subItem.uniform2
                    }, null, 8, _hoisted_20),
                    _createElementVNode("td", {
                      class: "border text-center fw-bolder",
                      innerHTML: subItem.campus
                    }, null, 8, _hoisted_21)
                  ], 64))
                : (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _createElementVNode("td", _hoisted_23, [
                      (subItem.idgroup1 == null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(subItem.equipos[1].business) + " (Descansa) ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(subItem.equipos[0].business) + " (Descansa) ", 1))
                    ])
                  ]))
            ]))
          }), 128))
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}